import { useAtomValue } from 'jotai';
import { Button } from '@tailwindComponents/Button';
import { classNames } from '../../../utils/classes';
import { sidebarCollapsedAtom } from '../../../store/jotai';

export interface PanelSaveStripProps {
  isSaving: boolean;
  isSaveEnabled: boolean;
  onCancel: () => void;
  onSave: () => void;
}

export function saveStripOffsetClass(isSidebarCollapsed: boolean) {
  return isSidebarCollapsed ? 'lg:left-16' : 'lg:left-64';
}

export function PanelSaveStrip({
  isSaving,
  isSaveEnabled,
  onCancel,
  onSave,
}: PanelSaveStripProps) {
  const isSidebarCollapsed = useAtomValue(sidebarCollapsedAtom);

  return (
    <div
      className={classNames(
        'fixed bottom-0 left-0 right-0 z-modalPanel flex items-center justify-between bg-blue-100 px-10 py-2 transition-all duration-300 ease-in-out',
        saveStripOffsetClass(isSidebarCollapsed)
      )}
    >
      <Button
        intent='tertiary'
        size='sm'
        label='Cancel'
        disabled={isSaving}
        onClick={onCancel}
      />
      <Button
        intent='primary'
        size='sm'
        label={isSaving ? 'Saving...' : 'Save'}
        disabled={isSaving || !isSaveEnabled}
        onClick={onSave}
      />
    </div>
  );
}
